import { styled } from '../../theme';

export const RowButtonContainer = styled.div`
  display: flex;
  flex-shrink: 1;
  padding-left: 8px;
  padding-right: 8px;
  min-width: 180px;
`;
